var $c1ce9d969bfa6909$exports = {};
// Fix Chart.js import - use script tag in HTML instead
// import Chart from 'chart.js/auto';
// The above import was causing issues since you're not using a bundler
// DOM Elements
const $c1ce9d969bfa6909$var$taskInput = document.getElementById('taskInput');
const $c1ce9d969bfa6909$var$taskDate = document.getElementById('taskDate');
const $c1ce9d969bfa6909$var$taskPriority = document.getElementById('taskPriority');
const $c1ce9d969bfa6909$var$addTaskBtn = document.getElementById('addTask');
const $c1ce9d969bfa6909$var$taskList = document.getElementById('taskList');
const $c1ce9d969bfa6909$var$filterBtns = document.querySelectorAll('.filter-btn');
const $c1ce9d969bfa6909$var$viewBtns = document.querySelectorAll('.view-btn');
const $c1ce9d969bfa6909$var$analyzerTabs = document.querySelectorAll('.analyzer-tab');
const $c1ce9d969bfa6909$var$totalTasksEl = document.getElementById('totalTasks');
const $c1ce9d969bfa6909$var$completedTasksEl = document.getElementById('completedTasks');
const $c1ce9d969bfa6909$var$completionRateEl = document.getElementById('completionRate');
const $c1ce9d969bfa6909$var$dailyChart = document.getElementById('dailyChart');
const $c1ce9d969bfa6909$var$weeklyChart = document.getElementById('weeklyChart');
const $c1ce9d969bfa6909$var$monthlyChart = document.getElementById('monthlyChart');
const $c1ce9d969bfa6909$var$dailyPieChart = document.getElementById('dailyPieChart');
const $c1ce9d969bfa6909$var$weeklyPieChart = document.getElementById('weeklyPieChart');
const $c1ce9d969bfa6909$var$priorityPieChart = document.getElementById('priorityPieChart');
const $c1ce9d969bfa6909$var$todayProgress = document.getElementById('todayProgress');
const $c1ce9d969bfa6909$var$todayStats = document.getElementById('todayStats');
const $c1ce9d969bfa6909$var$mostProductiveDay = document.getElementById('mostProductiveDay');
const $c1ce9d969bfa6909$var$weeklyGoalProgress = document.getElementById('weeklyGoalProgress');
const $c1ce9d969bfa6909$var$prevWeekBtn = document.getElementById('prevWeek');
const $c1ce9d969bfa6909$var$nextWeekBtn = document.getElementById('nextWeek');
const $c1ce9d969bfa6909$var$weekRange = document.getElementById('weekRange');
const $c1ce9d969bfa6909$var$monthDisplay = document.getElementById('monthDisplay');
const $c1ce9d969bfa6909$var$prevMonthBtn = document.getElementById('prevMonth');
const $c1ce9d969bfa6909$var$nextMonthBtn = document.getElementById('nextMonth');
const $c1ce9d969bfa6909$var$monthlyCompleted = document.getElementById('monthlyCompleted');
const $c1ce9d969bfa6909$var$productiveWeek = document.getElementById('productiveWeek');
const $c1ce9d969bfa6909$var$priorityFocus = document.getElementById('priorityFocus');
const $c1ce9d969bfa6909$var$allTaskCount = document.getElementById('allTaskCount');
const $c1ce9d969bfa6909$var$activeTaskCount = document.getElementById('activeTaskCount');
const $c1ce9d969bfa6909$var$completedTaskCount = document.getElementById('completedTaskCount');
const $c1ce9d969bfa6909$var$todayTaskCount = document.getElementById('todayTaskCount');
const $c1ce9d969bfa6909$var$todayCompletedCount = document.getElementById('todayCompletedCount');
const $c1ce9d969bfa6909$var$todayActiveCount = document.getElementById('todayActiveCount');
// Chart references
let $c1ce9d969bfa6909$var$chartInstances = {
    dailyChart: null,
    weeklyChart: null,
    monthlyChart: null,
    dailyPieChart: null,
    weeklyPieChart: null,
    monthlyPieChart: null
};
// State
let $c1ce9d969bfa6909$var$tasks = JSON.parse(localStorage.getItem('tasks')) || [];
let $c1ce9d969bfa6909$var$currentFilter = 'all';
let $c1ce9d969bfa6909$var$currentView = 'daily';
let $c1ce9d969bfa6909$var$currentWeek = new Date();
let $c1ce9d969bfa6909$var$currentMonthDate = new Date();
let $c1ce9d969bfa6909$var$currentMonth = new Date();
let $c1ce9d969bfa6909$var$selectedDay = null;
// Initialize the application
function $c1ce9d969bfa6909$var$init() {
    // Set today's date as default for new tasks
    const today = new Date().toISOString().split('T')[0];
    if ($c1ce9d969bfa6909$var$taskDate) $c1ce9d969bfa6909$var$taskDate.value = today;
    // Setup event listeners for task management
    if ($c1ce9d969bfa6909$var$addTaskBtn) $c1ce9d969bfa6909$var$addTaskBtn.addEventListener('click', $c1ce9d969bfa6909$var$handleAddTask);
    if ($c1ce9d969bfa6909$var$taskInput) $c1ce9d969bfa6909$var$taskInput.addEventListener('keypress', (e)=>{
        if (e.key === 'Enter') $c1ce9d969bfa6909$var$handleAddTask();
    });
    // Setup filter buttons
    if ($c1ce9d969bfa6909$var$filterBtns && $c1ce9d969bfa6909$var$filterBtns.length > 0) $c1ce9d969bfa6909$var$filterBtns.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const filter = btn.getAttribute('data-filter');
            if (filter) $c1ce9d969bfa6909$var$filterTasks(filter);
        });
    });
    // Setup view buttons
    if ($c1ce9d969bfa6909$var$viewBtns && $c1ce9d969bfa6909$var$viewBtns.length > 0) $c1ce9d969bfa6909$var$viewBtns.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const view = btn.getAttribute('data-view');
            if (view) $c1ce9d969bfa6909$var$switchView(view);
        });
    });
    // Setup analyzer tabs
    if ($c1ce9d969bfa6909$var$analyzerTabs && $c1ce9d969bfa6909$var$analyzerTabs.length > 0) $c1ce9d969bfa6909$var$analyzerTabs.forEach((tab)=>{
        tab.addEventListener('click', ()=>{
            const tabView = tab.getAttribute('data-tab');
            if (tabView) $c1ce9d969bfa6909$var$switchAnalyzerTab(tabView);
        });
    });
    // Setup week navigation
    if ($c1ce9d969bfa6909$var$prevWeekBtn) $c1ce9d969bfa6909$var$prevWeekBtn.addEventListener('click', $c1ce9d969bfa6909$var$goToPrevWeek);
    if ($c1ce9d969bfa6909$var$nextWeekBtn) $c1ce9d969bfa6909$var$nextWeekBtn.addEventListener('click', $c1ce9d969bfa6909$var$goToNextWeek);
    // Setup month navigation
    if ($c1ce9d969bfa6909$var$prevMonthBtn) $c1ce9d969bfa6909$var$prevMonthBtn.addEventListener('click', $c1ce9d969bfa6909$var$goToPrevMonth);
    if ($c1ce9d969bfa6909$var$nextMonthBtn) $c1ce9d969bfa6909$var$nextMonthBtn.addEventListener('click', $c1ce9d969bfa6909$var$goToNextMonth);
    // Load tasks from local storage
    $c1ce9d969bfa6909$var$loadTasks();
    // Load saved view preference
    const savedView = localStorage.getItem('currentView');
    if (savedView) $c1ce9d969bfa6909$var$currentView = savedView;
    // Initialize view
    $c1ce9d969bfa6909$var$switchView($c1ce9d969bfa6909$var$currentView);
    // Update stats and charts
    $c1ce9d969bfa6909$var$updateStats();
    $c1ce9d969bfa6909$var$updateWeekDisplay();
    $c1ce9d969bfa6909$var$initializeCharts();
    // Log initialization status to help with debugging
    console.log('App initialized. Current view:', $c1ce9d969bfa6909$var$currentView);
}
// Save tasks to local storage
function $c1ce9d969bfa6909$var$saveTasks() {
    localStorage.setItem('tasks', JSON.stringify($c1ce9d969bfa6909$var$tasks));
    $c1ce9d969bfa6909$var$updateStats();
    $c1ce9d969bfa6909$var$updateCharts();
    $c1ce9d969bfa6909$var$renderTasks();
}
// Update createTaskElement to make it more robust
function $c1ce9d969bfa6909$var$createTaskElement(task) {
    if (!task) return null;
    try {
        // Function to get priority class
        const getPriorityClass = (priority)=>{
            switch(priority){
                case 'urgent-important':
                    return 'priority-urgent-important';
                case 'not-urgent-important':
                    return 'priority-not-urgent-important';
                case 'urgent-not-important':
                    return 'priority-urgent-not-important';
                case 'not-urgent-not-important':
                    return 'priority-not-urgent-not-important';
                default:
                    return '';
            }
        };
        // Function to get priority label
        const getPriorityLabel = (priority)=>{
            switch(priority){
                case 'urgent-important':
                    return 'Urgent & Important';
                case 'not-urgent-important':
                    return 'Not Urgent but Important';
                case 'urgent-not-important':
                    return 'Urgent but Not Important';
                case 'not-urgent-not-important':
                    return 'Not Urgent & Not Important';
                default:
                    return '';
            }
        };
        const li = document.createElement('li');
        li.className = `task-item ${task.completed ? 'completed' : ''} ${getPriorityClass(task.priority)}`;
        li.dataset.id = task.id;
        const taskDate = $c1ce9d969bfa6909$var$formatDate(task.date);
        li.innerHTML = `
      <div class="task-content">
        <label class="checkbox-container">
          <input type="checkbox" ${task.completed ? 'checked' : ''}>
          <span class="checkmark"></span>
        </label>
        <div class="task-info">
          <p class="task-text">${task.text}</p>
          <div class="task-meta">
            <span class="task-date"><i class="far fa-calendar"></i> ${taskDate}</span>
            <span class="task-priority">${getPriorityLabel(task.priority)}</span>
          </div>
        </div>
      </div>
      <button class="delete-btn"><i class="fas fa-trash"></i></button>
    `;
        // Add event listeners to the task item
        const checkbox = li.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.addEventListener('change', ()=>{
            $c1ce9d969bfa6909$var$toggleTask(task.id);
        });
        const deleteBtn = li.querySelector('.delete-btn');
        if (deleteBtn) deleteBtn.addEventListener('click', ()=>{
            $c1ce9d969bfa6909$var$deleteTask(task.id);
        });
        return li;
    } catch (error) {
        console.error('Error creating task element:', error, task);
        return null;
    }
}
// Format date for display
function $c1ce9d969bfa6909$var$formatDate(dateString) {
    const options = {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
}
// Add a new task
function $c1ce9d969bfa6909$var$handleAddTask() {
    const text = $c1ce9d969bfa6909$var$taskInput.value.trim();
    const date = $c1ce9d969bfa6909$var$taskDate.value;
    const priority = $c1ce9d969bfa6909$var$taskPriority.value;
    if (text && date && priority !== 'none') {
        $c1ce9d969bfa6909$var$addTask(text, date, priority);
        $c1ce9d969bfa6909$var$taskInput.value = '';
        $c1ce9d969bfa6909$var$taskPriority.value = 'none';
    // Keep the date as is for convenience when adding multiple tasks
    }
}
function $c1ce9d969bfa6909$var$addTask(text, date, priority) {
    const newTask = {
        id: Date.now(),
        text: text,
        date: date,
        priority: priority,
        completed: false,
        createdAt: new Date().toISOString()
    };
    $c1ce9d969bfa6909$var$tasks.push(newTask);
    $c1ce9d969bfa6909$var$saveTasks();
    $c1ce9d969bfa6909$var$renderTasks();
    $c1ce9d969bfa6909$var$updateStats();
    $c1ce9d969bfa6909$var$updateCharts();
}
// Toggle task completion status
function $c1ce9d969bfa6909$var$toggleTask(id) {
    $c1ce9d969bfa6909$var$tasks = $c1ce9d969bfa6909$var$tasks.map((task)=>task.id === id ? {
            ...task,
            completed: !task.completed
        } : task);
    $c1ce9d969bfa6909$var$saveTasks();
    $c1ce9d969bfa6909$var$renderTasks();
    $c1ce9d969bfa6909$var$updateStats();
    $c1ce9d969bfa6909$var$updateCharts();
}
// Delete a task
function $c1ce9d969bfa6909$var$deleteTask(id) {
    $c1ce9d969bfa6909$var$tasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.id !== id);
    $c1ce9d969bfa6909$var$saveTasks();
    $c1ce9d969bfa6909$var$renderTasks();
    $c1ce9d969bfa6909$var$updateStats();
    $c1ce9d969bfa6909$var$updateCharts();
}
// Filter tasks by status
function $c1ce9d969bfa6909$var$filterTasks(filter) {
    $c1ce9d969bfa6909$var$currentFilter = filter;
    $c1ce9d969bfa6909$var$filterBtns.forEach((btn)=>{
        btn.classList.toggle('active', btn.getAttribute('data-filter') === filter);
    });
    $c1ce9d969bfa6909$var$renderTasks();
}
// Update the switchView function
function $c1ce9d969bfa6909$var$switchView(view) {
    // Update current view
    $c1ce9d969bfa6909$var$currentView = view;
    // Update view buttons
    const viewButtons = document.querySelectorAll('.view-btn');
    viewButtons.forEach((btn)=>{
        btn.classList.toggle('active', btn.getAttribute('data-view') === view);
    });
    // Update view displays
    const taskViews = document.querySelectorAll('.task-view');
    taskViews.forEach((v)=>{
        v.classList.toggle('active', v.id === `${view}View`);
    });
    // Special handling for views that need refreshing
    if (view === 'weekly') $c1ce9d969bfa6909$var$renderWeekView();
    else if (view === 'matrix') $c1ce9d969bfa6909$var$renderMatrixView();
    else if (view === 'monthly') $c1ce9d969bfa6909$var$renderCalendar();
    else if (view === 'daily') $c1ce9d969bfa6909$var$renderDailyView();
    // Save current view preference
    localStorage.setItem('currentView', view);
}
// Switch between analyzer tabs
function $c1ce9d969bfa6909$var$switchAnalyzerTab(tab) {
    $c1ce9d969bfa6909$var$analyzerTabs.forEach((btn)=>{
        btn.classList.toggle('active', btn.getAttribute('data-tab') === tab);
    });
    document.querySelectorAll('.analysis-view').forEach((view)=>{
        view.classList.remove('active');
    });
    document.getElementById(`${tab}Analysis`).classList.add('active');
}
// Get week dates (Sunday to Saturday)
function $c1ce9d969bfa6909$var$getWeekDates(date) {
    const day = date.getDay(); // 0 for Sunday, 1 for Monday, etc.
    const diff = date.getDate() - day;
    const sunday = new Date(date);
    sunday.setDate(diff);
    const weekDates = [];
    for(let i = 0; i < 7; i++){
        const nextDate = new Date(sunday);
        nextDate.setDate(sunday.getDate() + i);
        weekDates.push(nextDate);
    }
    return weekDates;
}
// Navigate to previous week
function $c1ce9d969bfa6909$var$goToPrevWeek() {
    const prevWeek = new Date($c1ce9d969bfa6909$var$currentWeek);
    prevWeek.setDate(prevWeek.getDate() - 7);
    $c1ce9d969bfa6909$var$currentWeek = prevWeek;
    $c1ce9d969bfa6909$var$updateWeekDisplay();
    $c1ce9d969bfa6909$var$renderWeekView();
}
// Navigate to next week
function $c1ce9d969bfa6909$var$goToNextWeek() {
    const nextWeek = new Date($c1ce9d969bfa6909$var$currentWeek);
    nextWeek.setDate(nextWeek.getDate() + 7);
    $c1ce9d969bfa6909$var$currentWeek = nextWeek;
    $c1ce9d969bfa6909$var$updateWeekDisplay();
    $c1ce9d969bfa6909$var$renderWeekView();
}
// Update week display
function $c1ce9d969bfa6909$var$updateWeekDisplay() {
    const weekDates = $c1ce9d969bfa6909$var$getWeekDates($c1ce9d969bfa6909$var$currentWeek);
    const startDate = weekDates[0].toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
    });
    const endDate = weekDates[6].toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
    });
    $c1ce9d969bfa6909$var$weekRange.textContent = `Week of ${startDate} - ${endDate}`;
}
// Format date to YYYY-MM-DD for comparison
function $c1ce9d969bfa6909$var$formatDateForComparison(date) {
    return date.toISOString().split('T')[0];
}
// Render tasks based on current view and filter
function $c1ce9d969bfa6909$var$renderTasks() {
    if ($c1ce9d969bfa6909$var$currentView === 'daily') $c1ce9d969bfa6909$var$renderDailyView();
    else if ($c1ce9d969bfa6909$var$currentView === 'weekly') $c1ce9d969bfa6909$var$renderWeekView();
    else if ($c1ce9d969bfa6909$var$currentView === 'matrix') $c1ce9d969bfa6909$var$renderMatrixView();
    else if ($c1ce9d969bfa6909$var$currentView === 'monthly') $c1ce9d969bfa6909$var$renderCalendar();
}
// Render daily view
function $c1ce9d969bfa6909$var$renderDailyView() {
    // Get today's date in YYYY-MM-DD format for comparison
    const today = new Date().toISOString().split('T')[0];
    // Filter tasks based on the currentFilter
    const filteredTasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>{
        if ($c1ce9d969bfa6909$var$currentFilter === 'all') return true;
        if ($c1ce9d969bfa6909$var$currentFilter === 'active') return !task.completed;
        if ($c1ce9d969bfa6909$var$currentFilter === 'completed') return task.completed;
        return true;
    });
    // Count today's tasks
    const todayTasksList = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.date === today);
    const todayCompletedList = todayTasksList.filter((task)=>task.completed);
    const todayActiveList = todayTasksList.filter((task)=>!task.completed);
    // Update task counts if elements exist
    if ($c1ce9d969bfa6909$var$todayTaskCount) $c1ce9d969bfa6909$var$todayTaskCount.textContent = todayTasksList.length;
    if ($c1ce9d969bfa6909$var$todayCompletedCount) $c1ce9d969bfa6909$var$todayCompletedCount.textContent = todayCompletedList.length;
    if ($c1ce9d969bfa6909$var$todayActiveCount) $c1ce9d969bfa6909$var$todayActiveCount.textContent = todayActiveList.length;
    if ($c1ce9d969bfa6909$var$allTaskCount) $c1ce9d969bfa6909$var$allTaskCount.textContent = $c1ce9d969bfa6909$var$tasks.length;
    if ($c1ce9d969bfa6909$var$activeTaskCount) $c1ce9d969bfa6909$var$activeTaskCount.textContent = $c1ce9d969bfa6909$var$tasks.filter((task)=>!task.completed).length;
    if ($c1ce9d969bfa6909$var$completedTaskCount) $c1ce9d969bfa6909$var$completedTaskCount.textContent = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.completed).length;
    // Update task list if element exists
    if ($c1ce9d969bfa6909$var$taskList) {
        // Clear the task list
        $c1ce9d969bfa6909$var$taskList.innerHTML = '';
        // Add filtered tasks to the list
        filteredTasks.forEach((task)=>{
            const taskElement = $c1ce9d969bfa6909$var$createTaskElement(task);
            if (taskElement) $c1ce9d969bfa6909$var$taskList.appendChild(taskElement);
        });
    }
    // Update today's progress indicators
    $c1ce9d969bfa6909$var$updateTodayProgressIndicators(todayTasksList, todayCompletedList);
}
// Add the updateTodayProgressIndicators function
function $c1ce9d969bfa6909$var$updateTodayProgressIndicators(todayTasks, completedTasks) {
    // Update today's progress bar if it exists
    const progressBar = document.getElementById('todayProgress');
    const statsText = document.getElementById('todayStats');
    if (progressBar || statsText) {
        const todayTasksCount = todayTasks.length;
        const completedCount = completedTasks.length;
        const progressPercentage = todayTasksCount > 0 ? completedCount / todayTasksCount * 100 : 0;
        if (progressBar) progressBar.style.width = `${progressPercentage}%`;
        if (statsText) statsText.textContent = `${completedCount}/${todayTasksCount} tasks completed`;
    }
}
// Render weekly view
function $c1ce9d969bfa6909$var$renderWeekView() {
    // Get dates for the current week
    const weekDates = $c1ce9d969bfa6909$var$getWeekDates($c1ce9d969bfa6909$var$currentWeek);
    // Clear all day columns
    document.querySelectorAll('.day-column .day-tasks').forEach((column)=>{
        column.innerHTML = '';
    });
    // Add tasks to the appropriate day columns
    weekDates.forEach((date, index)=>{
        const formattedDate = $c1ce9d969bfa6909$var$formatDateForComparison(date);
        const dayTasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.date === formattedDate);
        const dayColumn = document.querySelector(`.day-column[data-day="${index}"] .day-tasks`);
        dayTasks.forEach((task)=>{
            dayColumn.appendChild($c1ce9d969bfa6909$var$createTaskElement(task));
        });
    });
}
// Render matrix view
function $c1ce9d969bfa6909$var$renderMatrixView() {
    // Clear all quadrants
    document.querySelectorAll('.matrix-quadrant .matrix-tasks').forEach((quadrant)=>{
        quadrant.innerHTML = '';
    });
    // Filter tasks by priority and add to appropriate quadrants
    const quadrant1Tasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.priority === 'urgent-important');
    const quadrant2Tasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.priority === 'not-urgent-important');
    const quadrant3Tasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.priority === 'urgent-not-important');
    const quadrant4Tasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.priority === 'not-urgent-not-important');
    const quadrant1 = document.querySelector('#quadrant1 .matrix-tasks');
    const quadrant2 = document.querySelector('#quadrant2 .matrix-tasks');
    const quadrant3 = document.querySelector('#quadrant3 .matrix-tasks');
    const quadrant4 = document.querySelector('#quadrant4 .matrix-tasks');
    quadrant1Tasks.forEach((task)=>{
        quadrant1.appendChild($c1ce9d969bfa6909$var$createTaskElement(task));
    });
    quadrant2Tasks.forEach((task)=>{
        quadrant2.appendChild($c1ce9d969bfa6909$var$createTaskElement(task));
    });
    quadrant3Tasks.forEach((task)=>{
        quadrant3.appendChild($c1ce9d969bfa6909$var$createTaskElement(task));
    });
    quadrant4Tasks.forEach((task)=>{
        quadrant4.appendChild($c1ce9d969bfa6909$var$createTaskElement(task));
    });
}
// Update stats
function $c1ce9d969bfa6909$var$updateStats() {
    // Calculate total stats
    const totalTasksCount = $c1ce9d969bfa6909$var$tasks.length;
    const completedTasksCount = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.completed).length;
    const completionRate = totalTasksCount > 0 ? Math.round(completedTasksCount / totalTasksCount * 100) : 0;
    // Update total stats display
    $c1ce9d969bfa6909$var$totalTasksEl.textContent = totalTasksCount;
    $c1ce9d969bfa6909$var$completedTasksEl.textContent = completedTasksCount;
    $c1ce9d969bfa6909$var$completionRateEl.textContent = `${completionRate}%`;
    // Update today's stats
    const today = new Date().toISOString().split('T')[0];
    const todayTasksList = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.date === today);
    const todayCompletedCount = todayTasksList.filter((task)=>task.completed).length;
    const todayTasksCount = todayTasksList.length;
    const todayProgressPercentage = todayTasksCount > 0 ? todayCompletedCount / todayTasksCount * 100 : 0;
    $c1ce9d969bfa6909$var$todayProgress.style.width = `${todayProgressPercentage}%`;
    $c1ce9d969bfa6909$var$todayStats.textContent = `${todayCompletedCount}/${todayTasksCount} tasks completed`;
    // Find most productive day
    const dayNames = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];
    const dayTaskCounts = Array(7).fill(0);
    $c1ce9d969bfa6909$var$tasks.forEach((task)=>{
        if (task.completed) {
            const taskDate = new Date(task.date);
            const dayOfWeek = taskDate.getDay();
            dayTaskCounts[dayOfWeek]++;
        }
    });
    const maxTaskCount = Math.max(...dayTaskCounts);
    if (maxTaskCount > 0) {
        const mostProductiveIndex = dayTaskCounts.indexOf(maxTaskCount);
        $c1ce9d969bfa6909$var$mostProductiveDay.textContent = dayNames[mostProductiveIndex];
    } else $c1ce9d969bfa6909$var$mostProductiveDay.textContent = '-';
    // Update weekly goal progress
    $c1ce9d969bfa6909$var$weeklyGoalProgress.textContent = `${completionRate}%`;
}
// Initialize charts
function $c1ce9d969bfa6909$var$initializeCharts() {
    // Helper function to create or update a chart
    const createOrUpdateChart = (canvasId, chartType, chartKey, data, options)=>{
        try {
            const canvas = document.getElementById(canvasId);
            if (!canvas) return;
            // Destroy existing chart instance if it exists
            if ($c1ce9d969bfa6909$var$chartInstances[chartKey]) $c1ce9d969bfa6909$var$chartInstances[chartKey].destroy();
            // Create new chart
            const ctx = canvas.getContext('2d');
            if (ctx) $c1ce9d969bfa6909$var$chartInstances[chartKey] = new Chart(ctx, {
                type: chartType,
                data: data,
                options: options || {
                    responsive: true,
                    maintainAspectRatio: false
                }
            });
        } catch (error) {
            console.error(`Error creating ${chartKey}:`, error);
        }
    };
    // Update charts with current data
    $c1ce9d969bfa6909$var$updateCharts();
}
// Update all charts
function $c1ce9d969bfa6909$var$updateCharts() {
    try {
        // Helper function to get dates for the last 7 days
        const getLast7Days = ()=>{
            const dates = [];
            for(let i = 6; i >= 0; i--){
                const date = new Date();
                date.setDate(date.getDate() - i);
                dates.push(date.toISOString().split('T')[0]);
            }
            return dates;
        };
        // Helper function to get last 6 months
        const getLast6Months = ()=>{
            const months = [];
            const monthNames = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ];
            for(let i = 5; i >= 0; i--){
                const date = new Date();
                date.setDate(1); // First day of month
                date.setMonth(date.getMonth() - i);
                months.push({
                    date: new Date(date),
                    label: `${monthNames[date.getMonth()]} ${date.getFullYear()}`
                });
            }
            return months;
        };
        const dates = getLast7Days();
        const completedCounts = dates.map((date)=>$c1ce9d969bfa6909$var$tasks.filter((task)=>task.date === date && task.completed).length);
        // Daily Chart Data
        const dailyChartData = {
            labels: dates.map((date)=>new Date(date).toLocaleDateString('en-US', {
                    weekday: 'short'
                })),
            datasets: [
                {
                    label: 'Tasks Completed',
                    data: completedCounts,
                    backgroundColor: '#3498db'
                }
            ]
        };
        // Weekly Chart Data
        const weeks = [];
        for(let i = 3; i >= 0; i--){
            const date = new Date();
            date.setDate(date.getDate() - i * 7);
            const weekStart = new Date(date);
            weekStart.setDate(date.getDate() - date.getDay());
            weeks.push(weekStart);
        }
        const weeklyData = weeks.map((weekStart)=>{
            const weekEnd = new Date(weekStart);
            weekEnd.setDate(weekStart.getDate() + 6);
            return $c1ce9d969bfa6909$var$tasks.filter((task)=>{
                const taskDate = new Date(task.date);
                return taskDate >= weekStart && taskDate <= weekEnd && task.completed;
            }).length;
        });
        const weeklyChartData = {
            labels: weeks.map((date)=>{
                const endDate = new Date(date);
                endDate.setDate(date.getDate() + 6);
                return `${date.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                })} - ${endDate.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                })}`;
            }),
            datasets: [
                {
                    label: 'Tasks Completed',
                    data: weeklyData,
                    borderColor: '#3498db',
                    backgroundColor: 'rgba(52, 152, 219, 0.2)',
                    tension: 0.1,
                    fill: true
                }
            ]
        };
        // Monthly Chart Data
        const months = getLast6Months();
        const monthlyData = months.map((month)=>{
            const nextMonth = new Date(month.date);
            nextMonth.setMonth(nextMonth.getMonth() + 1);
            return $c1ce9d969bfa6909$var$tasks.filter((task)=>{
                const taskDate = new Date(task.date);
                return taskDate >= month.date && taskDate < nextMonth && task.completed;
            }).length;
        });
        const monthlyChartData = {
            labels: months.map((month)=>month.label),
            datasets: [
                {
                    label: 'Tasks Completed',
                    data: monthlyData,
                    backgroundColor: '#3498db'
                }
            ]
        };
        // Today's tasks for daily stats
        const today = new Date().toISOString().split('T')[0];
        const todayTasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.date === today);
        const todayCompleted = todayTasks.filter((task)=>task.completed).length;
        // Daily Pie Chart Data
        const dailyPieData = {
            labels: [
                'Completed',
                'Active'
            ],
            datasets: [
                {
                    data: [
                        todayCompleted,
                        Math.max(0, todayTasks.length - todayCompleted)
                    ],
                    backgroundColor: [
                        '#27ae60',
                        '#e74c3c'
                    ]
                }
            ]
        };
        // Weekly Pie Chart Data
        const dayNames = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ];
        const dayTaskCounts = Array(7).fill(0);
        $c1ce9d969bfa6909$var$tasks.forEach((task)=>{
            if (task.completed) {
                const taskDate = new Date(task.date);
                const dayOfWeek = taskDate.getDay();
                dayTaskCounts[dayOfWeek]++;
            }
        });
        const weeklyPieData = {
            labels: dayNames,
            datasets: [
                {
                    data: dayTaskCounts,
                    backgroundColor: [
                        '#1abc9c',
                        '#2ecc71',
                        '#3498db',
                        '#9b59b6',
                        '#e74c3c',
                        '#f1c40f',
                        '#e67e22'
                    ]
                }
            ]
        };
        // Monthly Pie Chart Data - By Priority
        const priorityCounts = {
            'urgent-important': 0,
            'not-urgent-important': 0,
            'urgent-not-important': 0,
            'not-urgent-not-important': 0
        };
        $c1ce9d969bfa6909$var$tasks.forEach((task)=>{
            if (task.priority && priorityCounts.hasOwnProperty(task.priority)) priorityCounts[task.priority]++;
        });
        const monthlyPieData = {
            labels: [
                'Urgent & Important',
                'Not Urgent but Important',
                'Urgent but Not Important',
                'Not Urgent & Not Important'
            ],
            datasets: [
                {
                    data: [
                        priorityCounts['urgent-important'],
                        priorityCounts['not-urgent-important'],
                        priorityCounts['urgent-not-important'],
                        priorityCounts['not-urgent-not-important']
                    ],
                    backgroundColor: [
                        '#e74c3c',
                        '#3498db',
                        '#f1c40f',
                        '#1abc9c'
                    ]
                }
            ]
        };
        // Update most productive week and priority focus
        $c1ce9d969bfa6909$var$updateMonthlyStats();
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        stepSize: 1
                    }
                }
            }
        };
        const pieChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'bottom'
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                            let label = context.label || '';
                            let value = context.raw || 0;
                            let total = context.dataset.data.reduce((a, b)=>a + b, 0);
                            let percentage = total > 0 ? Math.round(value / total * 100) : 0;
                            return `${label}: ${value} (${percentage}%)`;
                        }
                    }
                }
            }
        };
        // Create/update all charts (only if the elements exist)
        if (document.getElementById('dailyChart')) $c1ce9d969bfa6909$var$updateChart('dailyChart', 'bar', 'dailyChart', dailyChartData, chartOptions);
        if (document.getElementById('weeklyChart')) $c1ce9d969bfa6909$var$updateChart('weeklyChart', 'line', 'weeklyChart', weeklyChartData, chartOptions);
        if (document.getElementById('monthlyChart')) $c1ce9d969bfa6909$var$updateChart('monthlyChart', 'bar', 'monthlyChart', monthlyChartData, chartOptions);
        if (document.getElementById('dailyPieChart')) $c1ce9d969bfa6909$var$updateChart('dailyPieChart', 'pie', 'dailyPieChart', dailyPieData, pieChartOptions);
        if (document.getElementById('weeklyPieChart')) $c1ce9d969bfa6909$var$updateChart('weeklyPieChart', 'pie', 'weeklyPieChart', weeklyPieData, pieChartOptions);
        if (document.getElementById('monthlyPieChart')) $c1ce9d969bfa6909$var$updateChart('monthlyPieChart', 'pie', 'monthlyPieChart', monthlyPieData, pieChartOptions);
    } catch (error) {
        console.error("Error updating charts:", error);
    }
}
// Update the updateChart function to safely handle Chart.js
function $c1ce9d969bfa6909$var$updateChart(canvasId, chartType, chartKey, data, options) {
    try {
        const canvas = document.getElementById(canvasId);
        if (!canvas) return;
        // Check if Chart is defined
        if (typeof Chart === 'undefined') {
            console.error('Chart.js is not loaded');
            return;
        }
        // Destroy existing chart instance if it exists
        if ($c1ce9d969bfa6909$var$chartInstances[chartKey]) $c1ce9d969bfa6909$var$chartInstances[chartKey].destroy();
        // Create new chart
        const ctx = canvas.getContext('2d');
        if (ctx) $c1ce9d969bfa6909$var$chartInstances[chartKey] = new Chart(ctx, {
            type: chartType,
            data: data,
            options: options || {
                responsive: true,
                maintainAspectRatio: false
            }
        });
    } catch (error) {
        console.error(`Error updating ${chartKey}:`, error);
    }
}
// Initialize the app when the DOM is ready
document.addEventListener('DOMContentLoaded', $c1ce9d969bfa6909$var$init);
// Remove the redundant initializeMonthlyView function as we now handle it in init
// and update renderCalendar to work directly
function $c1ce9d969bfa6909$var$renderCalendar() {
    const calendarDays = document.getElementById('calendarDays');
    if (!calendarDays) return; // Exit if element not found
    const monthDisplayEl = document.getElementById('monthDisplay');
    // Clear previous calendar
    calendarDays.innerHTML = '';
    // Set month display
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    monthDisplayEl.textContent = `${monthNames[$c1ce9d969bfa6909$var$currentMonth.getMonth()]} ${$c1ce9d969bfa6909$var$currentMonth.getFullYear()}`;
    // Calculate first day of the month
    const firstDay = new Date($c1ce9d969bfa6909$var$currentMonth.getFullYear(), $c1ce9d969bfa6909$var$currentMonth.getMonth(), 1);
    const firstDayIndex = firstDay.getDay(); // 0 for Sunday
    // Calculate last day of the month
    const lastDay = new Date($c1ce9d969bfa6909$var$currentMonth.getFullYear(), $c1ce9d969bfa6909$var$currentMonth.getMonth() + 1, 0);
    const totalDays = lastDay.getDate();
    // Calculate last day of previous month
    const prevLastDay = new Date($c1ce9d969bfa6909$var$currentMonth.getFullYear(), $c1ce9d969bfa6909$var$currentMonth.getMonth(), 0);
    const prevLastDayDate = prevLastDay.getDate();
    // Calculate days to show from next month
    const nextDays = 7 - ((firstDayIndex + totalDays) % 7 || 7);
    // Render days from previous month
    for(let i = firstDayIndex; i > 0; i--){
        const dayEl = $c1ce9d969bfa6909$var$createCalendarDay(prevLastDayDate - i + 1, true);
        calendarDays.appendChild(dayEl);
    }
    // Render days of current month
    const today = new Date();
    for(let i = 1; i <= totalDays; i++){
        const isToday = i === today.getDate() && $c1ce9d969bfa6909$var$currentMonth.getMonth() === today.getMonth() && $c1ce9d969bfa6909$var$currentMonth.getFullYear() === today.getFullYear();
        const dayEl = $c1ce9d969bfa6909$var$createCalendarDay(i, false, isToday);
        // Add tasks for this day
        const dayDate = new Date($c1ce9d969bfa6909$var$currentMonth.getFullYear(), $c1ce9d969bfa6909$var$currentMonth.getMonth(), i).toISOString().split('T')[0];
        $c1ce9d969bfa6909$var$addTasksToCalendarDay(dayEl, dayDate);
        calendarDays.appendChild(dayEl);
    }
    // Render days from next month
    for(let i = 1; i <= nextDays; i++){
        const dayEl = $c1ce9d969bfa6909$var$createCalendarDay(i, true);
        calendarDays.appendChild(dayEl);
    }
    // Update month summary
    $c1ce9d969bfa6909$var$updateMonthSummary();
}
function $c1ce9d969bfa6909$var$createCalendarDay(day, isOtherMonth, isToday = false) {
    const dayEl = document.createElement('div');
    dayEl.classList.add('calendar-day');
    if (isOtherMonth) dayEl.classList.add('other-month');
    if (isToday) dayEl.classList.add('today');
    const dateEl = document.createElement('div');
    dateEl.classList.add('calendar-date');
    dateEl.textContent = day;
    dayEl.appendChild(dateEl);
    const taskList = document.createElement('ul');
    taskList.classList.add('calendar-task-list');
    dayEl.appendChild(taskList);
    return dayEl;
}
function $c1ce9d969bfa6909$var$addTasksToCalendarDay(dayEl, dateStr) {
    const tasks = $c1ce9d969bfa6909$var$getTasks().filter((task)=>task.date === dateStr);
    const taskList = dayEl.querySelector('.calendar-task-list');
    if (tasks.length > 0) {
        // Add task count badge
        const countBadge = document.createElement('div');
        countBadge.classList.add('day-task-count');
        countBadge.textContent = tasks.length;
        dayEl.appendChild(countBadge);
        // Add tasks to the list (max 3)
        const maxToShow = Math.min(tasks.length, 3);
        for(let i = 0; i < maxToShow; i++){
            const taskItem = document.createElement('li');
            taskItem.classList.add('calendar-task-item');
            if (tasks[i].completed) taskItem.classList.add('completed');
            taskItem.textContent = $c1ce9d969bfa6909$var$truncateText(tasks[i].text, 15);
            taskItem.setAttribute('data-id', tasks[i].id);
            taskList.appendChild(taskItem);
        }
        // Add "more" indicator if needed
        if (tasks.length > 3) {
            const moreItem = document.createElement('li');
            moreItem.classList.add('calendar-task-item');
            moreItem.textContent = `+${tasks.length - 3} more`;
            taskList.appendChild(moreItem);
        }
    }
}
function $c1ce9d969bfa6909$var$updateMonthSummary() {
    // Get current month's start and end dates
    const startOfMonth = new Date($c1ce9d969bfa6909$var$currentMonth.getFullYear(), $c1ce9d969bfa6909$var$currentMonth.getMonth(), 1);
    const endOfMonth = new Date($c1ce9d969bfa6909$var$currentMonth.getFullYear(), $c1ce9d969bfa6909$var$currentMonth.getMonth() + 1, 0);
    const startDateStr = startOfMonth.toISOString().split('T')[0];
    const endDateStr = endOfMonth.toISOString().split('T')[0];
    // Filter tasks for this month
    const tasks = $c1ce9d969bfa6909$var$getTasks().filter((task)=>{
        return task.date >= startDateStr && task.date <= endDateStr;
    });
    const completedTasks = tasks.filter((task)=>task.completed);
    // Update summary
    document.getElementById('monthTaskCount').textContent = tasks.length;
    document.getElementById('monthCompletedCount').textContent = completedTasks.length;
    document.getElementById('monthActiveCount').textContent = tasks.length - completedTasks.length;
}
function $c1ce9d969bfa6909$var$truncateText(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
// Update the refresh function
function $c1ce9d969bfa6909$var$refreshView() {
    const storedView = localStorage.getItem('currentView');
    if (storedView) {
        $c1ce9d969bfa6909$var$currentView = storedView;
        $c1ce9d969bfa6909$var$switchView($c1ce9d969bfa6909$var$currentView);
    } else {
        $c1ce9d969bfa6909$var$renderDailyView();
        $c1ce9d969bfa6909$var$updateDailySummary();
    }
}
// Add updateDailySummary function
function $c1ce9d969bfa6909$var$updateDailySummary() {
    // Get today's date in YYYY-MM-DD format for comparison
    const today = new Date().toISOString().split('T')[0];
    // Count today's tasks
    const todayTasksList = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.date === today);
    const todayCompletedList = todayTasksList.filter((task)=>task.completed);
    const todayActiveList = todayTasksList.filter((task)=>!task.completed);
    // Update task counts
    $c1ce9d969bfa6909$var$todayTaskCount.textContent = todayTasksList.length;
    $c1ce9d969bfa6909$var$todayCompletedCount.textContent = todayCompletedList.length;
    $c1ce9d969bfa6909$var$todayActiveCount.textContent = todayActiveList.length;
}
// Add the missing getTasks function
function $c1ce9d969bfa6909$var$getTasks() {
    return $c1ce9d969bfa6909$var$tasks;
}
// Add month navigation functions
function $c1ce9d969bfa6909$var$goToPrevMonth() {
    $c1ce9d969bfa6909$var$currentMonth.setMonth($c1ce9d969bfa6909$var$currentMonth.getMonth() - 1);
    $c1ce9d969bfa6909$var$renderCalendar();
}
function $c1ce9d969bfa6909$var$goToNextMonth() {
    $c1ce9d969bfa6909$var$currentMonth.setMonth($c1ce9d969bfa6909$var$currentMonth.getMonth() + 1);
    $c1ce9d969bfa6909$var$renderCalendar();
}
// Add a loadTasks function to handle loading tasks from localStorage
function $c1ce9d969bfa6909$var$loadTasks() {
    try {
        const savedTasks = localStorage.getItem('tasks');
        if (savedTasks) {
            $c1ce9d969bfa6909$var$tasks = JSON.parse(savedTasks);
            console.log(`Loaded ${$c1ce9d969bfa6909$var$tasks.length} tasks from localStorage`);
        } else console.log('No saved tasks found');
    } catch (error) {
        console.error('Error loading tasks:', error);
        $c1ce9d969bfa6909$var$tasks = [];
    }
}
// Add updateMonthlyStats function
function $c1ce9d969bfa6909$var$updateMonthlyStats() {
    try {
        // Find most productive week
        const weeksData = [];
        // Calculate for the last 4 weeks
        for(let i = 0; i < 4; i++){
            const endDate = new Date();
            endDate.setDate(endDate.getDate() - i * 7);
            const startDate = new Date(endDate);
            startDate.setDate(endDate.getDate() - 6);
            const startDateStr = startDate.toISOString().split('T')[0];
            const endDateStr = endDate.toISOString().split('T')[0];
            const weekTasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>{
                const taskDate = task.date;
                return taskDate >= startDateStr && taskDate <= endDateStr && task.completed;
            });
            weeksData.push({
                week: i + 1,
                startDate: startDate,
                endDate: endDate,
                completedCount: weekTasks.length
            });
        }
        // Sort by number of completed tasks
        weeksData.sort((a, b)=>b.completedCount - a.completedCount);
        // Update most productive week
        const mostProductiveWeekEl = document.getElementById('mostProductiveWeek');
        if (mostProductiveWeekEl && weeksData.length > 0 && weeksData[0].completedCount > 0) {
            const week = weeksData[0];
            mostProductiveWeekEl.textContent = `Week ${week.week}: ${week.startDate.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric'
            })} - ${week.endDate.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric'
            })} (${week.completedCount} tasks)`;
        } else if (mostProductiveWeekEl) mostProductiveWeekEl.textContent = 'No completed tasks yet';
        // Find priority focus
        const priorityCounts = {
            'urgent-important': 0,
            'not-urgent-important': 0,
            'urgent-not-important': 0,
            'not-urgent-not-important': 0
        };
        $c1ce9d969bfa6909$var$tasks.forEach((task)=>{
            if (task.priority && priorityCounts.hasOwnProperty(task.priority)) priorityCounts[task.priority]++;
        });
        // Find highest priority
        let highestPriority = '';
        let highestCount = 0;
        for(const priority in priorityCounts)if (priorityCounts[priority] > highestCount) {
            highestCount = priorityCounts[priority];
            highestPriority = priority;
        }
        // Map priority to readable name
        const priorityNames = {
            'urgent-important': 'Urgent & Important',
            'not-urgent-important': 'Not Urgent but Important',
            'urgent-not-important': 'Urgent but Not Important',
            'not-urgent-not-important': 'Not Urgent & Not Important'
        };
        // Update priority focus
        const priorityFocusEl = document.getElementById('priorityFocus');
        if (priorityFocusEl && highestCount > 0) priorityFocusEl.textContent = priorityNames[highestPriority];
        else if (priorityFocusEl) priorityFocusEl.textContent = 'No tasks yet';
        // Update monthly goal progress
        const totalTasks = $c1ce9d969bfa6909$var$tasks.length;
        const completedTasks = $c1ce9d969bfa6909$var$tasks.filter((task)=>task.completed).length;
        const progressPercentage = totalTasks > 0 ? Math.round(completedTasks / totalTasks * 100) : 0;
        const monthlyGoalProgressEl = document.getElementById('monthlyGoalProgress');
        if (monthlyGoalProgressEl) monthlyGoalProgressEl.textContent = `${progressPercentage}%`;
    } catch (error) {
        console.error('Error updating monthly stats:', error);
    }
}


//# sourceMappingURL=repo.5579a5df.js.map
